export default __webpack_public_path__ + "static/media/iplPart2.f7366215.jpg";